import { BarChart } from '@mui/x-charts/BarChart';
import GridDefinitions from '../../../defaults/GridDefinitions.json';
import { axisClasses } from '@mui/x-charts/ChartsAxis';
import { chop } from '../../../utils/FormatHelper';
import FieldNames from '../../../defaults/FieldNames.json';

export default function TargetBarChart({gridRows, getLabel, entityTypeSelection}) {
  return (
    <BarChart
      dataset={gridRows}
      height={500}
      margin={{
        left: 100,
        right: 5,
        top: 80,
        bottom: 80,
      }}
      xAxis={[
        {
          scaleType: 'band',
          dataKey: GridDefinitions.TargetManagementGrid.name.value,
          label: getLabel(),
          labelStyle: {
            // Move the x-axis label with style
            transform: 'translateY(30px)',
            fontWeight: 'bold',
            textTransform: 'uppercase'
          },
          valueFormatter: (element, context) => 
            context.location === 'tick' && gridRows.length > 8
            ? `${chop(element, 4)}` 
            : element,
          
        },
      ]}
      sx={{
        [`.${axisClasses.left} .${axisClasses.label}`]: {
          // Move the y-axis label with CSS
          transform: 'translateX(-55px)',
          fontWeight: 'bold',
          textTransform: 'uppercase'
        },
      }}
      series={ entityTypeSelection === FieldNames.datasets.fuels ? [{ dataKey: GridDefinitions.LockedTargetManagementGrid.targetAcres.value, label: GridDefinitions.LockedTargetManagementGrid.targetAcres.header, color: "blue"}, { dataKey: GridDefinitions.LockedTargetManagementGrid.actualHFRAcres.value, label: GridDefinitions.LockedTargetManagementGrid.actualHFRAcres.header, color: "purple"}] : [{ dataKey: GridDefinitions.TargetManagementGrid.targetAcres.value, label: GridDefinitions.TargetManagementGrid.targetAcres.header, color: "blue"}, { dataKey: GridDefinitions.TargetManagementGrid.actualAcres.value, label: GridDefinitions.TargetManagementGrid.actualAcres.header, color: "purple"}]}
      yAxis={[{ label: 'Acres', valueFormatter: (value) => { return `${(value * 1).toLocaleString()}` } }]}
      slotProps={{ legend: { 
        labelStyle: {
          fontSize: 12, 
          textTransform: 'uppercase'
        }, 
        direction: 'row', 
        hidden: false, 
        position: {
          vertical: 'top', 
          horizontal: 'middle'
        } 
      }}}
    />
  );
}
